module.exports = __webpack_public_path__ + "img/4e332d1.jpg";